/*
 * @Author: Tina Huang
 * @Date: 2024-09-14 14:39:18
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-09-14 15:38:40
 * @Description:
 */
import { Input } from 'antd'
import FormItem from 'antd/es/form/FormItem'
export default function GoodMeForm() {
  return (
    <>
      <FormItem label="取餐编号" name="orderNumber">
        <Input placeholder="如：9877" />
      </FormItem>
      <FormItem label="下单昵称" name="orderName">
        <Input placeholder="如：咖啡免费的啾啾" />
      </FormItem>
      <FormItem label="用户等级" name="orderClass">
        <Input placeholder="如：V1" />
      </FormItem>
      <FormItem label="订单模式" name="orderMode">
        <Input placeholder="如：外送 1/2" />
      </FormItem>
      <FormItem label="下单时间" name="orderTime">
        <Input placeholder="如：12:11 08-28" />
      </FormItem>
      <FormItem label="订单商品" name="orderContent">
        <Input placeholder="如：生椰丝绒拿铁" />
      </FormItem>
      <FormItem label="客制做法" name="orderCus">
        <Input placeholder="如：去糖，正常冰" />
      </FormItem>
      <FormItem label="说些什么" name="orderMessage">
        <Input placeholder="如：灵感常驻 清爽真果茶" />
      </FormItem>
      <FormItem label="店铺电话" name="orderStore">
        <Input placeholder="如：这里是店名 199999999" />
      </FormItem>
    </>
  )
}
